module.exports = "/_next/static/images/new-hampshire-388971044a4e252e005424540056155a.svg";